import { formatTextToUseNewLineBeforeNumbers } from '../functions';
import { CHAT_ROLES } from '../constants';
import { sendMessage } from './api';

export const handleSendMessage = async ({
  prompt,
  addMessages,
}) => {
  if (prompt) {
    addMessages([{
      role: CHAT_ROLES.ME,
      content: ` ${formatTextToUseNewLineBeforeNumbers(prompt)}`,
    }]);

    try {
      const response = await sendMessage(prompt);

      addMessages([{
        role: CHAT_ROLES.TINA,
        content: formatTextToUseNewLineBeforeNumbers(response.msg),
      }]);
    } catch (error) {
      addMessages([{
        role: CHAT_ROLES.TINA,
        content: formatTextToUseNewLineBeforeNumbers('Our System is busy. <br> please again resubmit our question'),
      }]);
    }
  }
};
